import React, { useRef, useEffect } from 'react';
import Lottie from 'lottie-react';
import clickAnimData from '../assets/clickAnim.json';

interface ClickAnimationProps {
  isVisible: boolean;
  position: { x: number; y: number };
}

export const ClickAnimation: React.FC<ClickAnimationProps> = ({ isVisible, position }) => {
  const lottieRef = useRef<any>(null);

  useEffect(() => {
    if (isVisible && lottieRef.current) {
      // Reset and play the animation from the beginning
      lottieRef.current.goToAndStop(0, true);
      lottieRef.current.play();
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      className="fixed pointer-events-none z-[9999]"
      style={{
        left: position.x - 100, // Center the 200px animation (refreshed)
        top: position.y - 100,
        width: '200px',
        height: '200px',
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={clickAnimData}
        loop={false}
        autoplay={true}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};
